import React, { useEffect, useState } from "react";
import { motion, useInView } from "framer-motion";
import "./Homepage.scss";
import Navbar from "./../../components/Navbar/Navbar";
import Hero from "./Section/Hero";
import Intro from "./Section/Intro";
import Division from "./Section/Division";
import Productivity from "./Section/Productivity";
import FooterCredit from "../../components/Footer/FooterCredit";
import Woroworo from "../../components/Woroworo/Woroworo";
import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const sectionVariants = {
  hidden: { opacity: 0, y: 0 },
  visible: { opacity: 1, y: 0 },
};

const SectionWrapper = ({ children }) => {
  const ref = React.useRef(null);
  const inView = useInView(ref, { once: true, margin: "0px 0px -100px 0px" });

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={sectionVariants}
      transition={{ duration: 2, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
};

const Homepage = ({ user, userDB }) => {
  const location = useLocation();
  const userState = location.state || {};
  const [ann, setAnn] = useState(false);
  const navigate = useNavigate();

  const clearLocationState = () => {
    navigate(".", { replace: true, state: {} });
  };
  useEffect(() => {
    if (userState.successReg) {
      setAnn(true);
    }
  }, [userState.successReg]);
  const kefal = () => {
    setAnn(false);
    clearLocationState();
  };
  return (
    <motion.main
      initial="hidden"
      animate="visible"
      exit="hidden"
      variants={sectionVariants}
      className="body-homepage"
    >
      <Helmet>
        <title>KIRMAGO | Homepage</title>
      </Helmet>
      <Woroworo
        text={`Sukses melakukan registrasi di akun ${
          user && user.email
        }, selamat datang!`}
        kefal={kefal}
        popup={ann}
      />
      <Navbar user={user} />
      <section className="body-homepage">
        <Hero />
        <SectionWrapper>
          <Intro />
        </SectionWrapper>
        <SectionWrapper>
          <Division />
        </SectionWrapper>
        <SectionWrapper>
          <Productivity />
        </SectionWrapper>
      </section>
      <footer>
        <FooterCredit />
      </footer>
    </motion.main>
  );
};

export default Homepage;
